// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

// const toolbar = [
//   'fontsizeselect searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
//   'hr bullist numlist link image charmap preview anchor insertdatetime media table emoticons forecolor backcolor fullscreen'
// ];
// ['bold italic underline strikethrough blockquote code numlist bullist fontsizeselect forecolor backcolor alignleft removeformat']

const toolbar = ['bold italic underline strikethrough code numlist bullist fontsizeselect forecolor backcolor alignleft aligncenter alignright outdent indent removeformat image link'];

export default toolbar;
